import { render, staticRenderFns } from "./MyBuildingsPage.vue?vue&type=template&id=6335f77a&scoped=true&"
import script from "./MyBuildingsPage.vue?vue&type=script&lang=js&"
export * from "./MyBuildingsPage.vue?vue&type=script&lang=js&"
import style0 from "./MyBuildingsPage.vue?vue&type=style&index=0&id=6335f77a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6335f77a",
  null
  
)

export default component.exports